import { AlertCircleIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

type RootErrorAlertProps = {
  message: ReactNode;
  className?: string;
};

export function RootErrorAlert({ message, className }: RootErrorAlertProps) {
  return (
    <Alert
      className={cn("bg-destructive-soft", className)}
      variant="destructive"
    >
      <AlertCircleIcon />
      <AlertDescription>
        <p>{message}</p>
      </AlertDescription>
    </Alert>
  );
}
